import React from "react";

const Label = (props) => {
  const { label, classNameStyle } = props;
  return (
    <>
      <label className={classNameStyle}>{label}</label>
    </>
  );
};

export default Label;
